import { CLASS_PAGINATION, CLASS_PAGINATION_PAGE } from '@splidejs/splide';
import type { DynamicPaginationOptions } from './types';

export const DEFAULT_OPTIONS: DynamicPaginationOptions = {
  mainBullets: 1,
};

export const CLASS_PAGINATION_DYNAMIC = `${CLASS_PAGINATION}--dynamic`;
export const CLASS_PAGINATION_PAGE_HIDDEN = `${CLASS_PAGINATION_PAGE}--hidden`;
